import { apiClient } from '@indipia/shared';
import { SHARE_LOAD_TIMEOUT_MS } from '@indipia/shared-features';
import type { ApiResponse } from '@indipia/shared-types';
import { ORDER_VENDOR_PARAM, parseOrderVendorId, type ListFilter } from '../pages/share/vendorOrderList.logic';

// 받은 발주 목록 — 외부 링크(공유 쿠키 share_jwt, 목록 토큰) 전용 API. shareId 는 경로·본문·쿼리에 싣지 않는다(F-04 §9).
const BASE = '/schedule/order-share-lists/me';

/** 목록 조회 (READ). 응답 형태 검증은 화면(parseOrderList)이 한다. */
export async function fetchOrderList(filter: ListFilter, signal?: AbortSignal): Promise<unknown> {
  const res = await apiClient.get<ApiResponse<unknown>>(BASE, { params: { filter }, signal, timeout: SHARE_LOAD_TIMEOUT_MS });
  return res.data.data;
}

/**
 * 목록에서 건별 화면으로 들어온 경우의 쿼리 값. 목록 토큰으로 건별 API 를 부를 때 `orderVendorId` 가 필요하다.
 * 건별 토큰으로 직접 연 화면에서는 값이 없어 undefined(기존 동작).
 */
export function listEntryParams(): { [ORDER_VENDOR_PARAM]: number } | undefined {
  const id = parseOrderVendorId(typeof window === 'undefined' ? '' : window.location.search);
  return id === null ? undefined : { [ORDER_VENDOR_PARAM]: id };
}

/** 이미지 경로 등 URL 문자열에 목록 진입 표식을 덧붙인다(없으면 그대로). */
export function withListEntry(path: string): string {
  const p = listEntryParams();
  if (!p) return path;
  return `${path}${path.includes('?') ? '&' : '?'}${ORDER_VENDOR_PARAM}=${p[ORDER_VENDOR_PARAM]}`;
}
